// Shared helpers for the mock handlers.
import { ApiError } from '@/api/client';

/** Simulates network latency so loading states are exercisable. */
export const pause = (ms = 350): Promise<void> => new Promise((r) => setTimeout(r, ms));

let idCounter = 0;
export const mockId = (prefix: string): string =>
  `${prefix}_${Date.now().toString(36)}_${(idCounter++).toString(36)}${Math.random().toString(36).slice(2, 7)}`;

export const fail = (code: string, message: string): never => {
  throw new ApiError(code, message);
};

/** Deterministic index into a list from a string seed (spec §15: lookups must
 *  depend on the input, not on randomness). */
export const pickIndex = (seed: string, size: number): number => {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return hash % size;
};

export const maskAccount = (accountNumber: string): string =>
  `•••• ${accountNumber.slice(-4)}`;

export const paymentReference = (date: Date, counter: number): string => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `NOVA${yyyy}${mm}${dd}${String(counter).padStart(6, '0')}`;
};
